export class SapAgentCursor {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "subscriptionId",
            "baseName": "subscriptionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "token",
            "baseName": "token",
            "type": "string",
            "format": ""
        },
        {
            "name": "chunkSeq",
            "baseName": "chunkSeq",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "deltaToken",
            "baseName": "deltaToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SapAgentCursor.attributeTypeMap;
    }
    constructor() {
    }
}
